/* One gap between every anchored overlay and its trigger (Tooltip, Menu,
 * Popover), and Chakra's menu gutter, so swept overlays keep their geometry.
 * Not a prop: one distance, decided once. */
export const OVERLAY_OFFSET = 8;

/* The public placement names map onto React Aria's space-separated pairs.
 * left/right take no start/end variants: the census found no vertical
 * alignment need on the horizontal axis, and the union grows on evidence.
 * Shared by the anchored overlays; a direct import, never through the barrel. */
export const RAC_PLACEMENT = {
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
  'top-start': 'top start',
  'top-end': 'top end',
  'bottom-start': 'bottom start',
  'bottom-end': 'bottom end',
} as const;
